// @ts-nocheck
import { toastTypes } from '../../enums';
import { createOAuthIntegrationStore } from './_shared';

export default createOAuthIntegrationStore({
  partnerKey: 'Fanbridge',
  defaultConfigs: { enabled: false },
  toastKeys: { update: toastTypes.fanbridgeUpdateConfigs },
});
